import React, { useState, useMemo} from 'react';
import debounce from 'lodash.debounce';
import { getCustomerDetails } from '@gjensidige/se-my-pages-utils';
import { fetchCallRequest, getUserAuthLevel } from '../api/api/call-request';
import { dispatchProperMessage } from '../api/useStatusCode';
import { logInfoMessage, preparePayload } from '../api/utils';
import { 
  appText, 
  customerSelectionOptions, 
  getQueueDetails, 
  daysWithLabelAndValue, 
  defaultWorkingHours 
} from '../constants/texts';
import { reducer } from '../state/reducer';
import { CallMeActionKind, DayType, TimeslotOption } from '../types';
import UiCallMe from './ui-call-me/UiCallMe';
import { EnonicDataType } from '../types';

interface CallMeNowProps {
  configs?: EnonicDataType
}

export function MyPagesFeaturesCallMe({configs}: CallMeNowProps) {

  

  function formatPhoneNumber(number: string): string {
    let result;
    if(number.length === 10 && number.charAt(0) === '0'){
      result = "+46" + number.substring(1);
    } else {
      result = "+46" + number;
    }
  
    return result;
  }

  const [contactFormData, dispatch] = React.useReducer(reducer, {
    callMeActionStatus: 'initial',
    name: '',
    number: '',
    formErrors: {
      nameInvalid: false,
      numValidity: 'VALID'
    },
    isCustomer: '',
    callMeActionStatusMessage: ''
  });



  React.useEffect(() => {
    getUserAuthLevel().then((authLevel) => {
      if (authLevel && authLevel.value === 3) {
        getCustomerDetails().then((value) => {
          if (value) {
            dispatch({
              payload: value.name,
              type: CallMeActionKind.ENTER_NAME
            });
            dispatch({
              payload:
                value.phone.find((number) => number.primaryPhone)
                  ?.phoneNumber || '',
              type: CallMeActionKind.ENTER_NUM
            });
          }
        });
      }
    });
  }, []);
  const onChangeName = (name: string) => {
    dispatch({
      payload: name,
      type: CallMeActionKind.ENTER_NAME
    });
  };

  const onChangeNum = (num: string) => {
    dispatch({
      payload: num,
      type: CallMeActionKind.ENTER_NUM
    });
    debouncedMyFunction(num);
  };

  const debouncedMyFunction = React.useMemo(
    () =>
      debounce((num: string) => {
        dispatch({
          payload: num,
          type: CallMeActionKind.VALIDATE_ENTER_NUM
        });
      }, 750),
    [dispatch]
  );


  const onSelectCustomerRelationShip = (option: string) => {
    dispatch({
      type: CallMeActionKind.SELECT_CUSTOMER_RELATIONSHIP,
      payload: option
    });
  };
  const onFormSubmit = React.useCallback(() => {
    dispatch({
      payload: '',
      type: CallMeActionKind.SET_LOADING
    });
    const queDetails = getQueueDetails(configs, false);
    const callMePayload = preparePayload(contactFormData, queDetails, false);
    fetchCallRequest(callMePayload).then((value) => {
      dispatchProperMessage(value.code, dispatch);
    });
    logInfoMessage('call me request published');
  }, [contactFormData]);

  return (
    <UiCallMe
      appText={appText}
      contactFormData={contactFormData}
      events={{
        onFormSubmit,
        onChangeName,
        onChangeNum,
        onSelectCustomerRelationShip
      }}
      customerSelectionOptions={customerSelectionOptions}
      isScheduledCall={false}
    />
  );
}

export default MyPagesFeaturesCallMe;


